import { Game } from './types';

export const games: Game[] = [
  {
    name: 'Math Quest',
    description: 'Master fractions and decimals in an exciting adventure',
    subject: 'Mathematics',
    color: '#4558C8',
    topics: ['Fractions', 'Decimals', 'Percentages']
  },
  {
    name: 'Word Wizard',
    description: 'Enhance vocabulary and spelling through magical challenges',
    subject: 'English',
    color: '#DFF37D',
    topics: ['Vocabulary', 'Spelling', 'Grammar']
  },
  {
    name: 'Shape Explorer',
    description: 'Discover geometric properties through interactive puzzles',
    subject: 'Mathematics',
    color: '#4558C8',
    topics: ['2D Shapes', '3D Shapes', 'Angles']
  },
  {
    name: 'Story Creator',
    description: 'Build creative writing skills with interactive prompts',
    subject: 'English',
    color: '#DFF37D',
    topics: ['Writing', 'Narrative', 'Creative']
  }
];